module.exports = __webpack_public_path__ + "media/images/companyPage/impact-943b7b178a2e0d1d575846fd0e312b33.svg";